<script setup lang="ts">
const searchResultFiltersStore = useSearchResultFiltersStore();
const searchResultIndexStore = useSearchResultIndexStore();
const searchCriteriaStore = useSearchCriteriaStore();
</script>

<template>
  <div class="flex min-h-0 flex-1 flex-col divide-y overflow-y-auto">
    <div class="p-4"><ResultsFiltersStops /></div>
    <div class="p-4"><ResultsFiltersHours /></div>
    <template v-if="!searchCriteriaStore.committedIsMultiDestination">
      <div class="p-4"><ResultsFiltersDuration /></div>
      <div class="p-4"><ResultsFiltersAirports /></div>
    </template>
    <div class="p-4"><ResultsFiltersAirlines /></div>
  </div>
  <div class="flex gap-2 border-t p-4">
    <UiButton
      variant="tertiary"
      color="gray"
      class="flex-1 truncate hover:bg-transparent"
      :disabled="!searchResultFiltersStore.activeFiltersCount"
      @click="searchResultFiltersStore.resetFilters"
    >
      {{ $t('components.results.filters.resetAll') }}
    </UiButton>
    <slot :count="searchResultIndexStore.availableSearchResults.length" />
  </div>
</template>
